import React from 'react';
import {
  Route,
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
} from 'react-router-dom';
import InvalidRoute from '../components/common/InvalidRoute/InvalidRoute';
import Transactions from '../components/pages/Transactions/Transactions';
import Invoices from '../components/pages/Invoices/Invoices';
import Payouts from '../components/pages/Payouts/Payouts';
import Navigation from '../components/common/Navigation/Navigation';
import Login from '../components/pages/Login/Login';
import AuditLogs from '../components/pages/AuditLogs/AuditLog';

function Routing() {
  const router = createBrowserRouter(createRoutesFromElements(InnerRouting()));

  return <RouterProvider router={router} />;
}

function InnerRouting() {
  const routes = (
    <>
      <Route path="/" element={<Navigation />}>
        {/* <Route path="/dashboard" element={<Dashboard />} />          version-1 */}
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/invoice" element={<Invoices />} />
        <Route path="/payout" element={<Payouts />} />
        <Route path="/auditLog" element={<AuditLogs />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={<InvalidRoute />} />
    </>
  );

  return routes;
}

export default Routing;
